import "core-js/modules/es.error.cause.js";
function t() {
  const e = "There was a problem fetching user information. Please try again.";
  let n, i;
  return new Promise((a, c) => {
    function w() {
      clearInterval(n), c(new Error(e));
    }
    function s() {
      window != null && window.reiSession && (clearInterval(n), clearTimeout(i), a());
    }
    i = setTimeout(w, 5e3), n = setInterval(s, 300), s();
  });
}
const d = async () => {
  try {
    return await t(), window.reiSession.getUser();
  } catch (e) {
    return e;
  }
}, S = async (e) => {
  try {
    return await t(), window.reiSession.addChangeListener(e);
  } catch (r) {
    return r;
  }
}, h = async (e) => {
  try {
    return await t(), window.reiSession.emitUserChangeEvent(e);
  } catch (r) {
    return r;
  }
}, l = async (e, r = !1) => {
  try {
    return await t(), window.reiSession.setPreferredStore(e, r);
  } catch (o) {
    return o;
  }
}, E = async () => {
  try {
    return await t(), window.reiSession.getPreferredStore();
  } catch (e) {
    return e;
  }
};
export {
  S as addChangeListener,
  h as emitUserChangeEvent,
  E as getPreferredStore,
  d as getUser,
  l as setPreferredStore
};
